import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import {
  FaUniversity,
  FaCheckCircle,
  FaUserFriends,
  FaUsers,
  FaFlag,
  FaPlus,
  FaUserPlus,
  FaMapMarkerAlt,
  FaChartBar,
  FaDownload,
  FaCog,
  FaBullseye,
} from "react-icons/fa";
import { MdMeetingRoom, MdAssignment } from "react-icons/md";
import { FaMapLocationDot } from "react-icons/fa6";

import "../../Styles/AdminPollingBoothManagement.css";

function AdminPollingBoothManagement() {
  // ---------- STAT CARDS ----------
  const statCards = [
    {
      icon: <FaUniversity />,
      label: "TOTAL POLLING BOOTHS",
      value: "268",
      note: "All Booths in Kandukuru",
      color: "adminpollingbooth123-ic-blue",
    },
    {
      icon: <FaCheckCircle />,
      label: "ACTIVE BOOTHS",
      value: "248",
      note: "92.54% Active",
      color: "adminpollingbooth123-ic-green",
    },
    {
      icon: <FaUserFriends />,
      label: "TOTAL VOTERS",
      value: "1,02,350",
      note: "In All Booths",
      color: "adminpollingbooth123-ic-purple",
    },
    {
      icon: <FaUsers />,
      label: "BOOTH INCHARGES",
      value: "268",
      note: "100% Assigned",
      color: "adminpollingbooth123-ic-orange",
    },
    {
      icon: <FaFlag />,
      label: "PRIORITY BOOTHS",
      value: "35",
      note: "Needs Attention",
      color: "adminpollingbooth123-ic-red",
    },
  ];

  // ---------- BOOTH STATUS DONUT ----------
  const boothStatusData = [
    { name: "Strong Booths", value: 162, pct: "60.45%", color: "#16a34a" },
    { name: "Medium Booths", value: 76, pct: "28.36%", color: "#f59e0b" },
    { name: "Weak Booths", value: 30, pct: "11.19%", color: "#ef4444" },
  ];

  // ---------- MAP MARKERS (mock positions in %) ----------
  const mapMarkers = [
    { top: "18%", left: "30%", status: "strong" },
    { top: "22%", left: "55%", status: "strong" },
    { top: "28%", left: "70%", status: "weak" },
    { top: "35%", left: "20%", status: "weak" },
    { top: "40%", left: "42%", status: "strong" },
    { top: "38%", left: "60%", status: "medium" },
    { top: "48%", left: "35%", status: "strong" },
    { top: "52%", left: "55%", status: "strong" },
    { top: "58%", left: "25%", status: "weak" },
    { top: "62%", left: "48%", status: "strong" },
    { top: "68%", left: "65%", status: "strong" },
    { top: "72%", left: "38%", status: "strong" },
    { top: "78%", left: "55%", status: "weak" },
    { top: "45%", left: "78%", status: "strong" },
    { top: "25%", left: "40%", status: "strong" },
  ];

  const mapLegend = [
    { label: "Strong", count: "162 Booths", pct: "60.45%", color: "adminpollingbooth123-marker-strong" },
    { label: "Medium", count: "76 Booths", pct: "28.36%", color: "adminpollingbooth123-marker-medium" },
    { label: "Weak", count: "30 Booths", pct: "11.19%", color: "adminpollingbooth123-marker-weak" },
  ];

  // ---------- RECENT BOOTH ACTIVITIES ----------
  const activities = [
    {
      icon: <FaCheckCircle />,
      iconColor: "adminpollingbooth123-act-green",
      title: "Booth Visit Completed",
      meta: "Booth No. 145, Kandukuru",
      time: "2h ago",
      tag: "Completed",
      tagColor: "adminpollingbooth123-tag-green",
    },
    {
      icon: <FaUserFriends />,
      iconColor: "adminpollingbooth123-act-blue",
      title: "Voter Meeting Conducted",
      meta: "Booth No. 102, Kandukuru",
      time: "4h ago",
      tag: "Meeting",
      tagColor: "adminpollingbooth123-tag-blue",
    },
    {
      icon: <MdAssignment />,
      iconColor: "adminpollingbooth123-act-orange",
      title: "Survey Conducted",
      meta: "Booth No. 210, Kandukuru",
      time: "6h ago",
      tag: "Survey",
      tagColor: "adminpollingbooth123-tag-orange",
    },
    {
      icon: <FaUserPlus />,
      iconColor: "adminpollingbooth123-act-purple",
      title: "New Incharge Assigned",
      meta: "Booth No. 178, Kandukuru",
      time: "1d ago",
      tag: "Assigned",
      tagColor: "adminpollingbooth123-tag-purple",
    },
    {
      icon: <FaFlag />,
      iconColor: "adminpollingbooth123-act-red",
      title: "Priority Booth Identified",
      meta: "Booth No. 56, Kandukuru",
      time: "1d ago",
      tag: "Attention",
      tagColor: "adminpollingbooth123-tag-red",
    },
  ];

  // ---------- TOP BOOTHS TABLE ----------
  const topBooths = [
    { rank: 1, boothNo: 145, location: "Kandukuru (Rural)", strength: 95, status: "Strong" },
    { rank: 2, boothNo: 102, location: "Kandukuru (Town)", strength: 90, status: "Strong" },
    { rank: 3, boothNo: 210, location: "Nidubrolu", strength: 85, status: "Strong" },
    { rank: 4, boothNo: 178, location: "Velagalapudi", strength: 80, status: "Medium" },
    { rank: 5, boothNo: 56, location: "Kandukuru (Rural)", strength: 65, status: "Weak" },
  ];

  // ---------- BOOTH INCHARGE SUMMARY DONUT ----------
  const inchargeData = [
    { name: "Assigned", value: 268, color: "#16a34a" },
  ];

  // ---------- QUICK ACTIONS ----------
  const quickActions = [
    { icon: <FaPlus />, label: "Add New Booth", color: "adminpollingbooth123-qa-blue" },
    { icon: <FaUserPlus />, label: "Assign Incharge", color: "adminpollingbooth123-qa-green" },
    { icon: <FaMapMarkerAlt />, label: "Map View", color: "adminpollingbooth123-qa-purple" },
    { icon: <FaChartBar />, label: "View Reports", color: "adminpollingbooth123-qa-orange" },
    { icon: <FaDownload />, label: "Export Data", color: "adminpollingbooth123-qa-teal" },
    { icon: <FaCog />, label: "Manage Booths", color: "adminpollingbooth123-qa-red" },
  ];

  return (
    <div className="adminpollingbooth123-page">
      {/* ================= HEADER (top-left, no side images) ================= */}
      <div className="adminpollingbooth123-header">
        <h1 className="adminpollingbooth123-title">POLLING BOOTH MANAGEMENT</h1>
        <h2 className="adminpollingbooth123-subtitle-line">
          <span className="adminpollingbooth123-line" />
          KANDUKURU CONSTITUENCY
          <span className="adminpollingbooth123-line" />
        </h2>
        <p className="adminpollingbooth123-tagline">
          Strong Booths. Strong Leadership. Stronger Kandukuru.
        </p>
      </div>

      {/* ================= STAT CARDS ================= */}
      <div className="adminpollingbooth123-stats-grid">
        {statCards.map((s, i) => (
          <div className="adminpollingbooth123-stat-card" key={i}>
            <div className={`adminpollingbooth123-stat-icon ${s.color}`}>{s.icon}</div>
            <div className="adminpollingbooth123-stat-info">
              <span className="adminpollingbooth123-stat-label">{s.label}</span>
              <span className="adminpollingbooth123-stat-value">{s.value}</span>
              <span className="adminpollingbooth123-stat-note">{s.note}</span>
            </div>
          </div>
        ))}
      </div>

      {/* ================= ROW 1: STATUS / MAP / ACTIVITIES ================= */}
      <div className="adminpollingbooth123-row-3">
        {/* Booth Status Overview */}
        <div className="adminpollingbooth123-card">
          <div className="adminpollingbooth123-card-header">
            <h3>BOOTH STATUS OVERVIEW</h3>
          </div>

          <div className="adminpollingbooth123-donut-wrap">
            <div className="adminpollingbooth123-donut-chart-box">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={boothStatusData}
                    dataKey="value"
                    innerRadius={58}
                    outerRadius={85}
                    paddingAngle={2}
                  >
                    {boothStatusData.map((entry, i) => (
                      <Cell key={i} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div className="adminpollingbooth123-donut-center">
                <span className="adminpollingbooth123-donut-value">268</span>
                <span className="adminpollingbooth123-donut-sub">Total Booths</span>
              </div>
            </div>

            <div className="adminpollingbooth123-donut-legend">
              {boothStatusData.map((d, i) => (
                <div className="adminpollingbooth123-legend-row" key={i}>
                  <span
                    className="adminpollingbooth123-legend-dot"
                    style={{ background: d.color }}
                  />
                  <div className="adminpollingbooth123-legend-text">
                    <span className="adminpollingbooth123-legend-title">{d.name}</span>
                    <span className="adminpollingbooth123-legend-sub">
                      {d.value} ({d.pct})
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Booth Strength Map */}
        <div className="adminpollingbooth123-card">
          <div className="adminpollingbooth123-card-header">
            <h3>BOOTH STRENGTH MAP - KANDUKURU CONSTITUENCY</h3>
          </div>

          <div className="adminpollingbooth123-map-wrap">
            <div className="adminpollingbooth123-map-box">
              <span className="adminpollingbooth123-map-label adminpollingbooth123-map-label-1">Nidubrolu</span>
              <span className="adminpollingbooth123-map-label adminpollingbooth123-map-label-2">Velagalapudi</span>
              <span className="adminpollingbooth123-map-label adminpollingbooth123-map-label-3">Kandukuru</span>
              <span className="adminpollingbooth123-map-label adminpollingbooth123-map-label-4">Kovvur</span>
              <span className="adminpollingbooth123-map-label adminpollingbooth123-map-label-5">Pamarru</span>

              {mapMarkers.map((m, i) => (
                <span
                  key={i}
                  className={`adminpollingbooth123-marker adminpollingbooth123-marker-${m.status}`}
                  style={{ top: m.top, left: m.left }}
                />
              ))}
            </div>

            <div className="adminpollingbooth123-map-legend">
              {mapLegend.map((l, i) => (
                <div className="adminpollingbooth123-map-legend-item" key={i}>
                  <span className={`adminpollingbooth123-legend-dot ${l.color}`} />
                  <div className="adminpollingbooth123-legend-text">
                    <span className="adminpollingbooth123-legend-title">{l.label}</span>
                    <span className="adminpollingbooth123-legend-sub">{l.count}</span>
                    <span className="adminpollingbooth123-legend-sub">{l.pct}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Recent Booth Activities */}
        <div className="adminpollingbooth123-card">
          <div className="adminpollingbooth123-card-header">
            <h3>RECENT BOOTH ACTIVITIES</h3>
          </div>

          <div className="adminpollingbooth123-activity-list">
            {activities.map((a, i) => (
              <div className="adminpollingbooth123-activity-item" key={i}>
                <span className={`adminpollingbooth123-activity-icon ${a.iconColor}`}>
                  {a.icon}
                </span>
                <div className="adminpollingbooth123-activity-info">
                  <span className="adminpollingbooth123-activity-title">{a.title}</span>
                  <span className="adminpollingbooth123-activity-meta">{a.meta}</span>
                </div>
                <div className="adminpollingbooth123-activity-right">
                  <span className="adminpollingbooth123-activity-time">{a.time}</span>
                  <span className={`adminpollingbooth123-activity-tag ${a.tagColor}`}>
                    {a.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ================= ROW 2: TOP BOOTHS / INCHARGE SUMMARY / QUICK ACTIONS ================= */}
      <div className="adminpollingbooth123-row-3">
        {/* Top Booths Table */}
        <div className="adminpollingbooth123-card">
          <div className="adminpollingbooth123-card-header">
            <h3>TOP BOOTHS (BY STRENGTH)</h3>
          </div>

          <table className="adminpollingbooth123-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Booth No.</th>
                <th>Location</th>
                <th>Strength</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {topBooths.map((b) => (
                <tr key={b.rank}>
                  <td>{b.rank}</td>
                  <td>{b.boothNo}</td>
                  <td>{b.location}</td>
                  <td>
                    <div className="adminpollingbooth123-strength-cell">
                      <div className="adminpollingbooth123-strength-track">
                        <div
                          className={`adminpollingbooth123-strength-fill adminpollingbooth123-strength-${b.status.toLowerCase()}`}
                          style={{ width: `${b.strength}%` }}
                        />
                      </div>
                      <span>{b.strength}%</span>
                    </div>
                  </td>
                  <td>
                    <span
                      className={`adminpollingbooth123-status-badge adminpollingbooth123-status-${b.status.toLowerCase()}`}
                    >
                      {b.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <a href="#!" className="adminpollingbooth123-viewall-link">
            View All Booths →
          </a>
        </div>

        {/* Booth Incharge Summary */}
        <div className="adminpollingbooth123-card">
          <div className="adminpollingbooth123-card-header">
            <h3>BOOTH INCHARGE SUMMARY</h3>
          </div>

          <div className="adminpollingbooth123-incharge-wrap">
            <div className="adminpollingbooth123-incharge-chart-box">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={[{ value: 100 }]}
                    dataKey="value"
                    innerRadius={58}
                    outerRadius={82}
                    startAngle={90}
                    endAngle={-270}
                  >
                    <Cell fill="#16a34a" />
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div className="adminpollingbooth123-incharge-center">
                <span className="adminpollingbooth123-incharge-value">268</span>
                <span className="adminpollingbooth123-incharge-sub">Total</span>
              </div>
            </div>

            <div className="adminpollingbooth123-incharge-legend">
              <div className="adminpollingbooth123-incharge-row">
                <span className="adminpollingbooth123-legend-dot adminpollingbooth123-dot-green" />
                <div className="adminpollingbooth123-legend-text">
                  <span className="adminpollingbooth123-legend-title">Assigned</span>
                  <span className="adminpollingbooth123-legend-sub">268 (100%)</span>
                </div>
              </div>
              <div className="adminpollingbooth123-incharge-row">
                <span className="adminpollingbooth123-legend-dot adminpollingbooth123-dot-red" />
                <div className="adminpollingbooth123-legend-text">
                  <span className="adminpollingbooth123-legend-title">Not Assigned</span>
                  <span className="adminpollingbooth123-legend-sub">0 (0%)</span>
                </div>
              </div>
            </div>
          </div>

          <div className="adminpollingbooth123-incharge-banner">
            <FaUsers className="adminpollingbooth123-banner-icon" />
            <span>
              All polling booths in Kandukuru Constituency have been assigned to incharges.
            </span>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="adminpollingbooth123-card">
          <div className="adminpollingbooth123-card-header">
            <h3>QUICK ACTIONS</h3>
          </div>

          <div className="adminpollingbooth123-qa-grid">
            {quickActions.map((q, i) => (
              <button className="adminpollingbooth123-qa-btn" key={i}>
                <span className={`adminpollingbooth123-qa-icon ${q.color}`}>{q.icon}</span>
                <span>{q.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ================= FOOTER GOAL BANNER ================= */}
      <div className="adminpollingbooth123-footer-banner">
        <FaBullseye className="adminpollingbooth123-footer-icon" />
        <span>
          Our Goal: Strong Booth Management for a Stronger Democracy in{" "}
          <b>Kandukuru Constituency.</b>
        </span>
      </div>
    </div>
  );
}

export default AdminPollingBoothManagement;